export const kg = value => Number.isFinite(Number(value)) ? Number(value) : 0
export const formatKg = value => new Intl.NumberFormat('es-AR').format(kg(value))
export const formatPercent = value => value == null ? 'Sin datos' : `${new Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(value)}%`
export const positiveInteger = value => (value !== '' && value != null && Number.isSafeInteger(Number(value)) && Number(value) > 0) || 'Ingrese un entero mayor que cero.'
export const nonNegativeInteger = value => (value !== '' && value != null && Number.isSafeInteger(Number(value)) && Number(value) >= 0) || 'Ingrese un entero mayor o igual a cero.'

export function summarizeProcess (inputs = [], outputs = []) {
  const inputKg = inputs.reduce((sum, item) => sum + kg(item.amount), 0)
  const outputKg = outputs.reduce((sum, item) => sum + kg(item.amount), 0)
  const exportKg = outputs.filter(item => item.qualityType?.qualityType === 'EXPORTACION').reduce((sum, item) => sum + kg(item.amount), 0)
  return { inputKg, outputKg, exportKg, differenceKg: inputKg - outputKg, exportEfficiency: inputKg > 0 ? exportKg * 100 / inputKg : null }
}

export function packagingTotals (items = []) {
  const totals = new Map()
  for (const item of items) {
    const label = item.packagingType?.packagingType || 'Sin envase'
    totals.set(label, (totals.get(label) || 0) + kg(item.bagQuantity))
  }
  return [...totals].map(([label, bags]) => ({ label, bags }))
}

export function originWarning (items = []) {
  const owner = new Set(items.map(item => item.owner))
  const grain = new Set(items.map(item => item.grainType?.id))
  if (owner.size > 1 || grain.size > 1) return 'El origen debe ser del mismo productor y tipo de grano. Revise la selección.'
  const origins = new Set(items.map(item => item.originLabel || item.sourceLabel || item.incomeId || item.sourceProcessId))
  const harvests = new Set(items.map(item => item.harvesting))
  return origins.size > 1 || harvests.size > 1 ? 'Este parte combina distintas procedencias o cosechas del mismo productor y grano. Se conservará la trazabilidad de cada origen.' : ''
}
